import SuggestionsList from "./list.vue"
import SuggestionsEdit from "./edit.vue";


let a = Object.assign({SuggestionsList,SuggestionsEdit});
export default a;